import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login',   
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/UserLogin.vue'), //登录页面
    
  },
  {
    path: '/mainIndex',
    name: 'mainIndex',
    redirect: '/welcome', 
    component: () => import('/src/components/MainIndex.vue'), //主菜单页面
    children: [
      {
        path: '/welcome', 
        name: 'welcome',
        component: () => import('/src/components/Welcome.vue')  //首页
      },
      {
        path: '/userinfo',
        name: 'userinfo',
        component: () => import('/src/components/UserInfo.vue') //个人中心
      },
      {
        path: '/userManage', 
        name: 'userManage',
        component: () => import('/src/views/system/UserManage.vue') //用户管理
      },
      {
        path: '/roleManage', 
        name: 'roleManage',
        component: () => import('/src/views/system/RoleManage.vue')  //角色管理
      },
      {
        path: '/questionManage', 
        name: 'questionManage',
        component: () => import('/src/views/manager/QuestionManage.vue'), //试题管理
      },
      {
        path: '/examPaperManage', 
        name: 'examPaperManage',
        component: () => import('/src/views/manager/ExamPaperManage.vue')//试卷管理
      },
      {
        path: '/examPaperSelect', 
        name: 'examPaperSelect',
        component: () => import('/src/views/manager/ExamPaperSelect.vue')//试卷抽取
      },
      
      {
        path: '/createExamPaper', 
        name: 'createExamPaper',
        component: () => import('/src/views/manager/ExamPaperManage.vue') //新增试卷
      },
      {
        path: '/examManage', 
        name: 'examManage',
        component: () => import('/src/views/manager/ExamManage.vue')//考试管理
      },
      {
        path: '/examRecord', 
        name:'examRecord',
        component: () => import('/src/views/manager/ExamRecord.vue') //考试记录
      },
      {
        path: '/examineeManage', 
        component: () => import('/src/views/manager/ExamineeManage.vue')//考生组管理
      },
      {
        path: '/userexamEnroll', 
        component: () => import('/src/views/examinee/UserExamEnroll.vue')//考试报名
      },
      {
        path: '/examOnline', 
        component: () => import('/src/views/examinee/ExamOnline.vue')//在线考试
      },
      {
        path: '/historyExam', 
        component: () => import('/src/views/examinee/HistoryExam.vue')//历史成绩
      },
      {
        path: '/examPage', 
        component: () => import('/src/views/examinee/ExamPage.vue')//考试页面
      },
    ]
  },


  // 考生端2026新路由
//   {
//     path: '/student',
//     name: 'StudentIndex',
//     component: () => import('/src/views/exam2026/StudentIndex.vue'),
//     meta: { requiresAuth: true, role: 'student' }
//   },
//   {
//     path: '/exam',
//     name: 'ExamPageNew',
//     component: () => import('/src/views/exam2026/ExamPageNew.vue'),
//     meta: { requiresAuth: true, role: 'student' }
//   },

]

const router = new VueRouter({
  routes
})




// 导航守卫
//使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     let token = localStorage.getItem('Authorization');

//     if (token === null || token === '') {
//       next('/login');
//     } else {
//       next();
//     }
//   }
// });



export default router
